const endPointsNonTrmEdition = {
    register: "talention/api/2.5/user/registration/custom",
    logout: "com/talention/api/2.0/authentication/signout",
    login: "com/talention/api/2.0/authentication/signin",
    authentication: "com/talention/api/2.0/authentication",
    password: "talention/api/2.0/recover-password/require"
};

const endPointsTrmEdition = {
    register: "talention/api/candidate/signup-backport",
    logout: "talention/api/candidate/logout",
    login: "talention/api/candidate/login",
    info: "talention/api/candidate/info",
    authentication: "com/talention/api/2.0/authentication", // ?????
    password: "talention/api/candidate/request-password-recovery",
    update: "talention/api/candidate/update",
};

const endPointsGeoSearch = {
    autocomplete: "talention/api/autocomplete-location",
    city: "talention/api/geocode",

};
const endPointsJobAgent = {
    create: "talention/api/job-agent/create",
    read: "talention/api/job-agent/list",
};

const endPointsJobMailer = {
    send: "ajax/common/job/mailer/post",
};

const endPointsTranslate = {
    translate: "talention/api/translate/career-site",
};

export {
    endPointsNonTrmEdition,
    endPointsTrmEdition,
    endPointsJobAgent,
    endPointsGeoSearch,
    endPointsJobMailer,
    endPointsTranslate
};
